// extracted by mini-css-extract-plugin
module.exports = {"storyblok-magazine-newsletter-subscription":"StoryblokMagazineNewsletterSubscription_storyblok-magazine-newsletter-subscription__ErVHl"};